import {Button} from "@material-ui/core";
import {Col, Row} from "antd";
import PublishList from "./PublishForm";
import PublicationList from "./PublicationList";
import useToggle from "../../shared/functions/useToggle";


export default function Publish() {

    const {open, handleOpen, handleClose} = useToggle();

    return (
        <Col>

            <Row justify={"end"}>
                <Button variant='contained' color='primary' onClick={handleOpen}>
                    Nouvelle Publication
                </Button>
            </Row>

            <PublicationList/>

            {
                open && (
                    <PublishList
                        handleClose={handleClose}
                    />
                )
            }

        </Col>
    )
}